import React from "react";
import "./Section1.css";
import Section1Image from "../../../../../assets/images/extensionsrsec-img1.png";
import Section1Dots from "../../../../../assets/images/aboutus-dots.png";
const Section1 = () => {
  return (
    <div className="extsrsrc1_section">
      <img src={Section1Dots} alt="" className="extsrsrc1__section_dots" />
      <div className="extsrsrc1__section_left">
        <img src={Section1Image} alt="" className="extsrsrc1__section_img" />
      </div>
      <div className="extsrsrc1__section_right">
        <div className="extsrsrc1__secleft_description">
          <p>
            If you can’t meet the April 15 deadline to file your tax return, you
            can get an automatic six-month extension of time to file from the
            IRS. The extension will give you extra time to get the paperwork
            into the IRS, but it does not extend the time you have to pay any
            tax due. You will owe interest on any amounts not paid by the April
            deadline, plus a late payment penalty if you have paid less than 90
            percent of your total tax by that date.
          </p>
          <p>
            You must make an accurate estimate of any tax due when you request
            an extension. You may also send a payment for the expected balance
            due, but this is not required to obtain the extension.
          </p>
          <p>
            To get the automatic extension, file Form 4868, Application for
            Extension of Time to File U.S. Individual Income Tax Return, with
            the IRS by the April 15 deadline, or make an extension-related
            electronic payment. You can file your extension request by computer
            or mail the paper Form 4868 to the IRS.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Section1;
